<div class="modal__content {{content_class}} js-modal__content">
  <div class="modal__header {{header_class}}">
    <{{heading_level}} class="modal__header__title {{title_class}}" id="{{id}}_label" tabindex="0">{{t header}}</{{heading_level}}>
    <div class="modal__header__close">
      <button type="button" class="btn btn-tertiary" {{#unless prevent_close_feedback}}data-close="true" {{/unless}}
        data-dismiss="modal" data-action-target="modal-header-close" {{#unless sr_close_caption}}aria-label="{{t 'closeModal'}}" {{/unless}}>
        {{>icon uuid=cid prefix="far" name="fa-xmark-large" size="fa-lg"}}
        <span class="screen-reader-content">{{#if sr_close_caption}}{{t sr_close_caption}}{{else}}{{t
          close_caption}}{{/if}}</span>
      </button>
    </div>
  </div>
  <div class="modal__body {{body_class}}">
    {{#if description}}<p>{{t description}}</p>{{/if}}
    {{#if customContent}}{{{customContent}}}{{/if}}
    {{#if blocks}}
    <div data-region="{{cid}}-modal-blocks"></div>
    {{/if}}
  </div>
  {{#unless no_footer}}
  <div class="modal__footer {{footer_class}}">
    <div class="modal__footer__close">
      <button type="button" class="btn {{#if button_class}}{{button_class}}{{else}}btn-tertiary btn-compact{{/if}}"
        data-dismiss="modal" data-action-target="modal-footer-close" {{#unless prevent_close_feedback}}data-close="true" {{/unless}}>

        {{#if button_icon_before}}
        {{>icon uuid=cid icon=button_icon_before classes=button_icon_before_classes}}
        {{/if}}

        {{#if sr_close_caption}}
        <span aria-hidden="true">{{t close_caption}}</span>
        <span class="screen-reader-content">{{t sr_close_caption}}</span>
        {{else}}
        {{t close_caption}}
        {{/if}}

        {{#if button_icon_after}}
        {{>icon uuid=cid icon=button_icon_after classes=button_icon_after_classes}}
        {{/if}}
      </button>
    </div>
    {{f 'editblock' '' cid forge_path 'modal'}}
  </div>
  {{/unless}}
</div>
